<template>
<div class="quiz_progress_item mt-1" :class="processbarcolor">
<ProgressBar :value="$store.state.evaluation.flow_process.progress_percentage" />
</div>
</template>

<script>
export default {

  name: 'FlowProcess',

  data () {
    return {

    }
  },
  computed:{
  	processbarcolor()
  	{
  		if(this.$store.state.evaluation.flow_process.progress_percentage==100)
  		{
  			return "concluded"
  		}
  		else
  		{
  			return "not_concluded"
  		}
  	}
  }
}
</script>

<style lang="css" >

	
</style>